import React from "react";
import {connect} from 'react-redux'
import {Link} from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

//Icons
import Accessibility from "@material-ui/icons/Accessibility";
import AddIcon from "@material-ui/icons/Add";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

//import Button from "components/CustomButtons/Button.jsx";
// core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";


import Table from "components/Table/Table.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox from "components/Checkbox/Checkbox";

//Table actions
import Actions from 'views/Tables/Actions'

//Approve popUp
import ConfirmAlert from 'components/Alert/Confirm'
import ProgressAlert from 'components/Alert/Progress'
import SuccessAlert from 'components/Alert/Success'

//Styles
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";


// Actions
import {
  ibFilter,
  ibsFetch,
  ibRemove
} from 'actions/ibs'

class List extends React.Component {
  selected=[]
  state = {
    selected: [],
    remoteFilters:{
      name: ''
    }
  }
  componentDidMount(){
    this.props.filter({size: 10,sort:{nameLowerCase: 'asc'}})
    this.props.fetch()
  }
  //on choose record
  select(id) {
    let select = []
    if (Array.isArray(id)) 
      select = (this.state.selected.length > 0)
        ? []
        : id
    else if (this.state.selected.indexOf(id) > -1) 
      select = this.state.selected.filter((e) => e !== id)
    else 
      select = this
        .state
        .selected
        .concat(id)
    this.setState({
      ...this.state,
      selected: select
    })
  }
  confirmDelete() {
      if(this.selected.length===0){
        this.props.fetch();
        this.setState({
          ...this.state,
          selected:[],
          alert: <SuccessAlert
            title={`Done!`}
            onConfirm={()=>{this.setState({...this.state,alert:false});}}
          />
        });
        return false;
      }
      this.setState({
        ...this.state,
        alert: <ProgressAlert
        value={100-((this.selected.length*100)/this.state.selected.length)}
        title={`Delete ibs (${this.state.selected.length-this.selected.length+'/'+this.state.selected.length})`}
        />
      });
      this.props.remove(this.selected[0])
        .then((e)=>{
          this.selected=this.selected.slice(1);
          this.confirmDelete();
        })
  }
  //on choose click delete 
  delete() {
    this.setState({
      ...this.state,
      alert: <ConfirmAlert
        text={`to delete ${this.state.selected.length} ibs \n( ${
          this.state.selected.map(id=>this.props.ibs.list.find(e=>e.ibId===id).name).join(', ')
        } )`}
        onCancel={()=>this.setState({...this.state,alert:false})}
        onConfirm={()=>{
          this.selected=this.state.selected.slice(0);
          this.confirmDelete();
      }}
      />
    });
  }
  //Filter change for pagination or limitation
  filter(filter){
    this.setState({...this.state,selected:[]})
    this.props.filter({
      ...this.props.ibs.pageable,
      ...filter,
      page: filter.size 
        ? 0 
        : filter.page !== undefined ? filter.page : this.props.ibs.pageable.page
    })
    this.props.fetch()
  }

fetchRemoteFilter(value, key){
    
    this.setState({
      ...this.state,
      remoteFilters: {
        ...this.state.remoteFilters,
        [key]: value
      }
    })

    this.props.fetch(value,false)

  }

  render() {
    const {match, ibs, permissions} = this.props;
    const selected = this.state.selected
    const filterColumns = [
      {
        name: 'name',
        filterChangeAction: (value, key) => this.fetchRemoteFilter(value, key),
        value: this.state.remoteFilters.name
      }
    ]
    return (
      <Card>
        {this.state.alert}
        {
        (!ibs.isFetching)?
        //Top actions (pgination/limit/add/remove/edit)
        <Actions
          onPagination={(page)=>this.filter({page:page-1})}
          limit={ibs.pageable.size}
          limitOptions={[10,100,200]}
          onLimitation={(page)=>this.filter({size:page})}
          pagination={ibs.pageable.totalPages>1?{
            pages:ibs.pageable.totalPages,
            current:ibs.pageable.page+1,
          }:false}
          title={(selected.length)
            ? this.state.selected.length + ' Selected'
            : ''}
          dark={selected.length>0}
          icon={<Accessibility/>}
          actions={{
          add: (selected.length===0)
            ? <Link to={`${match.path}/add`}>
                <IconButton>
                  <AddIcon/>
                </IconButton>
              </Link>
            : '',
            delete: (selected.length>0) && permissions.includes('IBS_DELETE')
              ? <IconButton onClick={this.delete.bind(this)}><DeleteIcon/></IconButton>
              : '',
            edit: (selected.length===1)
              ? <Link to={`${match.path}/${this.state.selected[0]}`}>
                  <IconButton>
                      <EditIcon/>
                  </IconButton>
                </Link>
              : ''
        }}/>:''}

        <CardBody>
          {/* If is fetching not display table*/}
          {((ibs.isFetching) || (!ibs.list))
            ? <LinearProgress color="primary"/>
            : (
              //Main table
              <div>
                {/* <Button
                  variant="contained"
                  color="info"
                  disableRipple
                  onClick={() => this.props.history.push(`${match.path}/add-wizard`)}
                >
                  Create/Edit Ib
                </Button> */}
                <Table
                  tableHeaderColor="primary"
                  sort={ibs.pageable.sort}
                  onSort={(e)=>this.filter({sort:{[e]:ibs.pageable.sort[e]==='desc'?'asc':'desc'}}) }
                  filterColumns={filterColumns}
                  tableHead={{ 
                      checkbox:<Checkbox props = {{ 
                        onClick:()=>this.select(ibs.list.map(e=>e.ibId)),
                        checked:(ibs.list) && this.state.selected.length===ibs.list.length}
                      }/>,
                      ibId:"#", 
                      name:"Name", 
                      address:"Address",
                      contactPersonJobPosition:"Contact Job Position", 
                      contactPersonFullName:"Contact Name" 
                    }}
                  tableData={ibs.list.map((e,i) => [ 
                      <Checkbox props = {{ onClick:()=>this.select(e.ibId), checked:this.state.selected.indexOf(e.ibId)>-1 }}/>,
                      e.ibId, 
                      e.name+' '+e.lastName, 
                      e.address, 
                      e.contactPersonJobPosition, 
                      e.contactPersonFullName 
                    ] )}
                />
              </div>
            )}
        </CardBody>
       { 
         ((ibs.list) && (ibs.list.length>20))
        ?<Actions
            onPagination={(page)=>this.filter({page:page-1})}
            pagination={ibs.pageable.totalPages>1?{
              pages:ibs.pageable.totalPages,
              current:ibs.pageable.page+1,
            }:false}
        />:''}
      </Card>
    );
  }
}
const mapStateToProps = (state) => ({
  ibs: state.ibs,
  permissions: state.auth.permissions
})
const mapDispatchToProps = (dispatch) => ({
  filter: (filter) => dispatch(ibFilter(filter)),
  fetch: (ibName,loading) => dispatch(ibsFetch(ibName,loading)),
  remove: (id) => dispatch(ibRemove(id)),
})
export default withStyles(buttonsStyle)(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/Ibs/List.jsx